import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { ICrudGetAllAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './audit-history.reducer';
import { IAuditHistory } from 'app/shared/model/audit-history.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IAuditHistoryProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const AuditHistory = (props: IAuditHistoryProps) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { auditHistoryList, match, loading } = props;
  return (
    <div>
      <h2 id="audit-history-heading">
        Audit Histories
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp; Create new Audit History
        </Link>
      </h2>
      <div className="table-responsive">
        {auditHistoryList && auditHistoryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Video Original Json</th>
                <th>Video New Json</th>
                <th>Updated By</th>
                <th>Updated On</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {auditHistoryList.map((auditHistory, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${auditHistory.id}`} color="link" size="sm">
                      {auditHistory.id}
                    </Button>
                  </td>
                  <td>{auditHistory.videoOriginalJson}</td>
                  <td>{auditHistory.videoNewJson}</td>
                  <td>{auditHistory.updatedBy}</td>
                  <td>
                    {auditHistory.updatedOn ? (
                      <TextFormat type="date" value={auditHistory.updatedOn} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${auditHistory.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${auditHistory.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${auditHistory.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Audit Histories found</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ auditHistory }: IRootState) => ({
  auditHistoryList: auditHistory.entities,
  loading: auditHistory.loading,
});

const mapDispatchToProps = {
  getEntities,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AuditHistory);
